import React, { useState } from "react";
import {
	PasswordConfirmationGetterContext,
	PasswordConfirmationSetterContext,
} from "@shared/context";

export default function PasswordConfirmationContainer(props: {
	children: React.ReactNode;
}) {
	const [showPasswordConfirmation, setShowPasswordConfirmation] =
		useState<boolean>(false);

	const passwordConfirmationSetterCtxValue = {
		setShowPasswordConfirmation: (condition: boolean) => {
			setShowPasswordConfirmation(condition);
		},
	};

	const passwordConfirmationGetterCtxValue = {
		showPasswordConfirmation: showPasswordConfirmation,
	};

	return (
		<PasswordConfirmationGetterContext.Provider
			value={passwordConfirmationGetterCtxValue}
		>
			<PasswordConfirmationSetterContext.Provider
				value={passwordConfirmationSetterCtxValue}
			>
				{props.children}
			</PasswordConfirmationSetterContext.Provider>
		</PasswordConfirmationGetterContext.Provider>
	);
}
